import React, { useCallback, useContext } from 'react'
import useTourV2PurchasableOptionDetails from 'hooks/TourV2/useTourV2PurchasableOptionDetails'
import { TourV2ContentSections } from 'constants/tours'
import PriceRowPriceWithCaption from 'components/Luxkit/PricePoints/PriceRowPriceWithCaption'
import PriceRowCaption from 'components/Luxkit/PricePoints/PriceRowCaption'
import OfferPageStickyFooter from 'components/OfferPage/OfferPageStickyFooter'
import ModalContext from 'contexts/ModalContext'
import { useScreenSizeOnly } from 'hooks/useScreenSize'
import TourV2DepartureBookingModal from '../Departures/TourV2DepartureBookingModal'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import PriceRowLuxPlusPriceWithCaption from 'components/Luxkit/PricePoints/LuxPlus/PriceRowLuxPlusPriceWithCaption'

interface Props {
  purchasableOption?: App.Tours.TourV2OfferPurchasableOption
  onScrollTo: (section: TourV2ContentSections) => void
  visible: boolean;
  offer: App.Tours.TourV2Offer;
}

function TourV2StickyFooter(props: Props) {
  const { purchasableOption, onScrollTo, visible, offer } = props

  const purchasableOptionDetails = useTourV2PurchasableOptionDetails(purchasableOption)

  const isMobile = useScreenSizeOnly('mobile')
  const showModal = useContext(ModalContext)
  const onCheckAvailability = useCallback(() => {
    if (isMobile) {
      showModal(<TourV2DepartureBookingModal offer={offer} />)
    } else {
      onScrollTo(TourV2ContentSections.DEPARTURES)
    }
  }, [isMobile, offer, onScrollTo, showModal])

  return (
    <OfferPageStickyFooter visible={visible} callToActionCopy="Check Availability" onCTAClick={onCheckAvailability}>
      {!!purchasableOptionDetails && <div>
        {!purchasableOptionDetails.memberPricePerPerson && <PriceRowPriceWithCaption
          size="M"
          caption="From"
          price={purchasableOptionDetails.pricePerPerson}
          saleUnit="person"
        />}
        {!!purchasableOptionDetails.memberPricePerPerson && <PriceRowLuxPlusPriceWithCaption
          size="M"
          caption="From"
          memberPrice={purchasableOptionDetails.memberPricePerPerson}
          saleUnit="person"
        />}

        <PriceRowCaption>
          {purchasableOptionDetails.roomTypeName}
        </PriceRowCaption>
      </div>}
    </OfferPageStickyFooter>
  )
}

type MappedProps = Pick<Props, 'offer'>

export default withOfferPageState((state): MappedProps => ({
  offer: state.tourV2Offer!,
}), TourV2StickyFooter)
